import httpClient from "@/http";
import qs from 'qs';
import debounce from "debounce";

export const SelectMixin = {
    props: {
        name: { type: String },
        label: { type: String },
        url: { type: String, default: null },
        initialData: { type: Array, default: () => { return [] } },  // данные без запроса
        idKey: {type: String, default: 'id' },
        labelKey: {type: String, default: 'name' },
        state: {type: String, default: '' },
        initialFilters: { type: Array, default: () => { return [] } },
        showPlaceholder: { type: Boolean, default: true },
        hasSearch: { type: Boolean, default: true },  // TODO: поиск пока не поддерживается для списков с готовыми данными. Лучше выключать его явно, если задана initialData
        searchPlaceholder: {type: String, default: 'Поиск' },
        hasPagination: { type: Boolean, default: true },
    },
    data() {
        return {
            optionData: [],
            filters: {},
            page: 1,
            pagesCount: 1,
            dropdownVisible: false,
            loading: false,
            loadingError: false,
            searchTerm: null
        }
    },
    computed: {
        options() {
            return this.optionData.map(item => {
                let option = {};
                option['id'] = item['id'];
                option['text'] = item[this.labelKey];
                option['data'] = item
                return option
            })
        }
    },
    methods: {
        showDropdown() {
            this.dropdownVisible = true;
            // set position
            this.$nextTick(() => {
                const dropdownElement = this.$refs.dropdown;
                const dropdownDimensions = dropdownElement.getBoundingClientRect();
                const bodyDimensions = document.getElementsByTagName('body')[0].getBoundingClientRect();
                if (bodyDimensions.height < dropdownDimensions.y + dropdownDimensions.height) {
                    dropdownElement.style.top = bodyDimensions.height - (dropdownDimensions.y + dropdownDimensions.height + 20) + 'px';
                }
            })
        },
        hideDropdown() {
            this.dropdownVisible = false
        },
        prepareParams() {
            let params = {};
            if (this.hasPagination) {
                params.page = this.page
            }
            if (this.searchTerm) {
                params.search = this.searchTerm
            }
            if (this.initialFilters.length) {
                for (const filterItem of this.initialFilters) {
                    if (!params[filterItem.key]) {
                        params[filterItem.key] = []
                    }
                    params[filterItem.key].push(filterItem.value)
                }
            }
            return params
        },
        fetch() {
            const vm = this;

            if (!vm.url) {
                // если заданы готовые данные, не нужно делать запрос
                return new Promise((resolve) => {
                    vm.optionData = vm.initialData ? vm.initialData : [];
                    vm.pagesCount = 1
                    resolve()
                })
            }

            vm.loading = true;
            vm.loadingError = false;
            return new Promise((resolve, reject) => {
                httpClient.get(vm.url, {params: vm.prepareParams(), paramsSerializer: params => { return qs.stringify(params, {arrayFormat: 'repeat'}) }})
                    .then((result) => {
                        if (vm.hasPagination) {
                            vm.optionData = result.data['results'] ? result.data['results'] : [];
                            vm.pagesCount = result.data['total_pages']
                        } else {
                            vm.optionData = result.data ? result.data : [];
                            vm.pagesCount = 1
                        }
                        // console.log(vm.optionData)
                        resolve(result)
                    })
                    .catch((reason) => {
                        vm.optionData = [];
                        vm.pagesCount = 0;
                        vm.loadingError = true;
                        resolve()
                    })
            })
        },
        onShowList() {
            const vm = this;
            this.fetch().then(() => { vm.loading = false; vm.showDropdown(); });
        },
        onChangePage(direction) {
            const vm = this;
            this.page = this.page + direction;
            this.fetch().then(() => { setTimeout(() => {vm.loading = false;}, 300)  })
        },
        onSearch(e) {
            this.page = 1;
            this.searchTerm = e.target.value;
            this.search(this);
        },
        search: debounce((vm) => {
            vm.fetch()
                .then((data) => {
                    vm.loading = false;
                    vm.showDropdown()
                });
        }, 500),
    }
}